import React from "react";
import { Form, Input, Select, Typography } from "antd";
import TextArea from "antd/es/input/TextArea";
// import { USER_GROUP_ENUM } from "..";
import { useTranslation } from "react-i18next";
import { NotificationType } from "../../../../../hooks/api/notifications";
import PhoneNumberInput from "../../../../Common/PhoneNumberInput";
import AlternativePhoneInput from "../../../../Common/AlternativePhoneInput";
import { enumToOptionsArray } from "../../../../../utils";
import { UserRoleDisplay } from "../../../../../enums/user";

// Staff edit allows only these statuses.
const STATUS_OPTIONS = [
  { value: "pending", label: "Pending" },
  { value: "active", label: "Active" },
  { value: "inactive", label: "Inactive" },
  { value: "archived", label: "Archived" },
];

export default function UserCreateForm(): React.ReactElement {
  const form = Form.useFormInstance();
  const { t } = useTranslation();

  // const userGroupOptions = Object.entries(USER_GROUP_ENUM).map(
  //   ([value, obj]) => ({
  //     value,
  //     label: obj.text,
  //   }),
  // );
  const notificationTypeOptions = Object.entries(NotificationType).map(
    ([value, label]) => ({
      value,
      label: value,
    }),
  );

  return (
    <>
      <Form.Item label="Role" name="role" rules={[{ required: true }]}>
        <Select
          placeholder="Select"
          options={enumToOptionsArray(UserRoleDisplay)}
        />
      </Form.Item>
      <Form.Item
        label="Full Name"
        name="fullName"
        rules={[
          { required: true },
          {
            min: 3,
            max: 150,
          },
        ]}
      >
        <Input placeholder="Type here" />
      </Form.Item>
      <Form.Item
        label="Email"
        name="email"
        rules={[
          { required: true },
          {
            min: 3,
            max: 150,
          },
        ]}
      >
        <Input placeholder="Type here" disabled />
      </Form.Item>
      <Form.Item
        label="Phone"
        name="phone"
        rules={[
          { required: true },
          {
            min: 3,
            max: 150,
          },
        ]}
      >
        <AlternativePhoneInput />
      </Form.Item>
      <Form.Item
        label="Address"
        name="address"
        rules={[
          { required: true },
          {
            min: 3,
            max: 150,
          },
        ]}
      >
        <Input placeholder="e.g., 2118 Thornridge Cir. Syracuse, Connecticut 35624" />
      </Form.Item>
      <Form.Item label="Status" name="status" rules={[{ required: true }]}>
        <Select placeholder="Select" options={STATUS_OPTIONS} />
      </Form.Item>
      {/* <Form.Item
        label={t("pages.notificationCenter.userGroup")}
        name="group"
        rules={[{ required: true, message: t("validations.userGroup") }]}
      >
        <Select
          placeholder={t("placeholder.select")}
        // options={userGroupOptions}
        />
      </Form.Item>
      <Form.Item
        label={t("pages.notificationCenter.notificationType")}
        name="notificationType"
        rules={[{ required: true, message: t("validations.notificationType") }]}
      >
        <Select
          placeholder={t("placeholder.select")}
          options={notificationTypeOptions}
        />
      </Form.Item>
      <Form.Item
        label={t("pages.notificationCenter.title")}
        name="title"
        rules={[
          { required: true },
          {
            min: 3,
            max: 50,
          },
        ]}
      >
        <TextArea
          rows={2}
          showCount
          placeholder={t("placeholder.enterTitle")}
        />
      </Form.Item>

      <Form.Item
        label={t("pages.notificationCenter.message")}
        name="description"
        rules={[
          { required: true },
          {
            min: 3,
            max: 150,
          },
        ]}
      >
        <TextArea rows={4} placeholder={t("placeholder.enterMessage")} />
      </Form.Item> */}
    </>
  );
}
